import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function MainHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="relative z-10 border-b border-solid border-border-color bg-page-bg/90 px-6 py-3 dark:border-border-dark dark:bg-surface-dark/90 md:px-10">
      <div className="flex items-center justify-between whitespace-nowrap">
        <div className="flex items-center gap-4 text-text-color dark:text-text-dark">
          <div className="size-8 text-primary">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="h-full w-full object-contain" 
            />
          </div>
          <div className="flex flex-col">
            <h2 className="text-lg font-bold leading-tight tracking-[-0.015em] text-text-color dark:text-text-dark">
              Government of Karnataka
            </h2>
            <p className="text-xs font-medium text-text-color/70 dark:text-subtext-dark">
              Department of Mines and Geology
            </p>
          </div>
        </div>
        
        {/* Desktop Links */}
        <div className="hidden flex-1 justify-end gap-8 md:flex">
          <div className="flex items-center gap-9">
            <Link className="text-sm font-medium leading-normal text-text-color dark:text-text-dark" to="/dashboard">
              Dashboard
            </Link>
            <Link className="text-sm font-bold leading-normal text-primary" to="/dashboard">
              Applications
            </Link>
          </div>
        </div>
        
        {/* Mobile Hamburger Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-light text-text-color dark:bg-background-dark dark:text-text-dark md:hidden"
        >
          <span className="material-symbols-outlined text-2xl">
            {isMenuOpen ? 'close' : 'menu'}
          </span>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="absolute left-0 top-full w-full border-b border-border-color bg-page-bg p-4 shadow-md dark:border-border-dark dark:bg-surface-dark md:hidden">
          <nav className="flex flex-col gap-4">
            <Link 
              to="/dashboard" 
              className="text-sm font-medium leading-normal text-text-color dark:text-text-dark"
              onClick={() => setIsMenuOpen(false)}
            >
              Dashboard
            </Link>
            <Link 
              to="/dashboard" 
              className="text-sm font-bold leading-normal text-primary"
              onClick={() => setIsMenuOpen(false)}
            >
              Applications
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default MainHeader;
